import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/store";

import AppBar from "../../components/DefaultAppBar";
import DocumentSearchInput from "./components/DocumentSearch";
import DocumentsExpansionPanel from "./components/ExpansionPanels";
import DocumentFolderList from "./components/DocumentFolderList";

import LocationFilterToolbar from "../../App/LocationFilterToolbar";

import {
  fetchDocumentCategoriesThunk,
  fetchDocumentsThunk,
} from "../../modules/documents/documentOperations";
import { documentSelectors } from "../../modules/documents/documentsSlice";
import { documentCategorySelectors } from "../../modules/documents/documentCategoriesSlice";
import { Box } from "@mui/material";
import DocumentLayout from "../../components/Layouts/DocumentLayout";
import { currentEstateSelectors } from "@/modules/estate/currentEstate/currentEstateSlice";

export const route = "/documents";

function DocumentListContainer() {
  const { id } = useAppSelector(currentEstateSelectors.selectCurrentEstate);

  const documents = useAppSelector(documentSelectors.selectAll);
  const documentCategories = useAppSelector(
    documentCategorySelectors.selectAll,
  );
  const documentTextSearch = useAppSelector(documentSelectors.selectTextSearch);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchDocumentCategoriesThunk());
    dispatch(fetchDocumentsThunk({ estateId: id }));
  }, [dispatch, id]);

  return (
    <>
      <AppBar>
        <LocationFilterToolbar />
      </AppBar>

      <DocumentLayout>
        <Box sx={{ py: 3 }}>
          <DocumentSearchInput />
          <Box sx={{ mt: 2 }}>
            {documentTextSearch.length ? (
              <DocumentFolderList data={documents} />
            ) : (
              <DocumentsExpansionPanel
                primary={documentCategories}
                secondary={documents}
              />
            )}
          </Box>
        </Box>
      </DocumentLayout>
    </>
  );
}

DocumentListContainer.route = route;

export default DocumentListContainer;
